<template>
  <div>
    <div :class="`button-amount ${isPoll || isNps || isOpenField ? 'border-bottom' : ''}` ">      
      <v-radio-group v-model="selectedSurveyType">
        <v-radio
          v-for="(item, index) in surveyList"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></v-radio>
      </v-radio-group>
    </div>

    <app-poll v-if="isPoll"
              :data-interaction="interaction"
              @update="update"
              @add-option="addOption"
              @update-option="updateOption"
              @remove-option="removeOption"
              @reload="reloadOptions"></app-poll>

    <app-nps v-if="isNps"
             :data-interaction="interaction"
             @update-option="updateOption"
             @update="update"></app-nps>

    <open-field v-if="isOpenField"
                :data-interaction="interaction"
                @update-option="updateOption"
                @update="update"></open-field>
  </div>
</template>

<script>
    import AppNps from './Nps'
    import AppPoll from './Poll'
    import OpenField from './open-field/OpenField.vue'
    import panelBody from '../mixins/panel-body'


    export default {
      components:{
        AppNps,
        AppPoll,
        OpenField
      },
        data() {
          return {
            surveyList: [
              {label: 'Múltipla escolha', value: 'PESQUISA_OBJETIVA' },
              {label: 'NPS', value: 'PESQUISA_NPS' },
              {label: 'Campo aberto', value: 'OPEN_FIELD' }
            ],            
          }
        },
        props: {
          selectedType: {
            type: String,
            required: true,
          }
        },

        computed: {
          isNps() {
            return this.selectedType === 'PESQUISA_NPS'
          },
          isPoll() {
            return this.selectedType === 'PESQUISA_OBJETIVA'
          },
          isOpenField() {
            return this.selectedType === 'OPEN_FIELD'
          },
          selectedSurveyType: {
            get() {
              return this.selectedType
            },
            set(val) {
              this.selectSurvey(val)
            }
          }
        },

        mixins: [panelBody],

        methods: {
           selectSurvey(type) {
            this.$emit('selectType', type);
           },
           update(evt) {
             this.$emit('update', evt);
           },
           addOption() {
             this.$emit('add-option');
           },
           updateOption(data){
             this.$emit('update-option', data);
           },
           removeOption(option){
             this.$emit('remove-option', option);
           },
           reloadOptions() {
             this.$emit('reload')
           }

        }
    }


</script>

<style lang="scss" scoped>
@import "../mixins/panel-body";

.button-amount {
  display: flex;
  flex-direction: column;
 
  padding: 10px 30px 0 10px;
  font-size: 14px;
  font-weight: bold;

  .checkbox-wrapper {
    display: flex;
    align-items: center;

    .text {
      margin: 4px 0 0 -6px;
    }

    ::v-deep .v-input {
      flex: 0
    }    
  }

  ::v-deep .v-input--selection-controls {
    margin-top: 0;
  }
  ::v-deep .v-input__slot {
    margin-bottom: 0;
  }
  ::v-deep .v-label {
    font-size: 14px;
  }
}
</style>

